/**
 * Copy for the EHR sign-in method field (INT-69). Split out from
 * EhrIntegrationTypeField.tsx because that file exports a component —
 * react-refresh/only-export-components forbids mixing component and
 * non-component exports in the same file (see
 * src/pages/Prompts/promptReviewDiff.ts for the same pattern).
 */
import { EhrIntegrationTypeEnum } from "@api/rest/types-and-hooks";

export const EHR_INTEGRATION_TYPE_LABELS: Record<EhrIntegrationTypeEnum, string> = {
  [EhrIntegrationTypeEnum.STANDARD]: "Each provider's login",
  [EhrIntegrationTypeEnum.ORG_USERNAME_PASSWORD]: "Shared org login",
  [EhrIntegrationTypeEnum.DATA_WAREHOUSE]: "CentralReach data warehouse",
};

// One short sentence per type, used to build the editable field's tooltip
// from only the types actually offered (see EhrIntegrationTypeField) —
// mentioning a type that isn't an allowed option for this EHR would be
// misleading (e.g. "CentralReach data warehouse" on an EHR that doesn't support it).
export const EHR_INTEGRATION_TYPE_TOOLTIP_SENTENCES: Record<EhrIntegrationTypeEnum, string> = {
  [EhrIntegrationTypeEnum.STANDARD]: "every provider connects with their own EHR username and password.",
  [EhrIntegrationTypeEnum.ORG_USERNAME_PASSWORD]: "one org admin's EHR login covers everyone in the org.",
  [EhrIntegrationTypeEnum.DATA_WAREHOUSE]:
    "no login needed. Engineering connects Frontera to CentralReach's reporting database.",
};

export const EHR_INTEGRATION_TYPE_CONFIRM_TEXT: Record<EhrIntegrationTypeEnum, string> = {
  [EhrIntegrationTypeEnum.ORG_USERNAME_PASSWORD]:
    "Every active EHR session for this org will be ended. If no shared EHR credentials are stored yet, the org will show as disconnected until an org admin enters them in the portal.",
  [EhrIntegrationTypeEnum.STANDARD]:
    "Every active EHR session for this org will be ended. Each provider will need to connect their own EHR account.",
  [EhrIntegrationTypeEnum.DATA_WAREHOUSE]:
    "Every active EHR session for this org will be ended. Engineering must configure the data warehouse credentials before syncing works.",
};
